export default {
  path: '/',
  redirect: '/welcome'
}



// WEBPACK FOOTER //
// ./src/router/login/Default.js